export default function Rules() {
  return (
    <>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-6aad915 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="6aad915"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-no">
          <div
            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-417e7c0"
            data-id="417e7c0"
            data-element_type="column"
          >
            <div
              className="elementor-widget-wrap elementor-element-populated"
              style={{
                margin: 0,
              }}
            >
              <div
                className="elementor-element elementor-element-dcc34fa elementor-widget elementor-widget-heading"
                data-id="dcc34fa"
                data-element_type="widget"
                data-widget_type="heading.default"
              >
                <div className="elementor-widget-container">
                  <h2 className="elementor-heading-title elementor-size-default">
                    Solution-Driven Methods
                  </h2>
                </div>
              </div>
              <div
                className="elementor-element elementor-element-a39c50d elementor-widget elementor-widget-text-editor"
                data-id="a39c50d"
                data-element_type="widget"
                data-widget_type="text-editor.default"
              >
                <div className="elementor-widget-container">
                  <p>
                    We are fully committed to identifying and providing the best
                    solutions you might have
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-f88bc1a"
            data-id="f88bc1a"
            data-element_type="column"
          >
            <div
              className="elementor-widget-wrap elementor-element-populated"
              style={{
                margin: 0,
              }}
            >
              <div
                className="elementor-element elementor-element-55f5579 elementor-widget elementor-widget-heading"
                data-id="55f5579"
                data-element_type="widget"
                data-widget_type="heading.default"
              >
                <div className="elementor-widget-container">
                  <h2 className="elementor-heading-title elementor-size-default">
                    Out-of-the-Box Thinking
                  </h2>
                </div>
              </div>
              <div
                className="elementor-element elementor-element-645b817 elementor-widget elementor-widget-text-editor"
                data-id="645b817"
                data-element_type="widget"
                data-widget_type="text-editor.default"
              >
                <div className="elementor-widget-container">
                  <p>
                    Our unique approach combines simplified solutions with new
                    age systems
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-194c77f"
            data-id="194c77f"
            data-element_type="column"
          >
            <div
              className="elementor-widget-wrap elementor-element-populated"
              style={{
                margin: 0,
              }}
            >
              <div
                className="elementor-element elementor-element-4741e85 elementor-widget elementor-widget-heading"
                data-id="4741e85"
                data-element_type="widget"
                data-widget_type="heading.default"
              >
                <div className="elementor-widget-container">
                  <h2 className="elementor-heading-title elementor-size-default">
                    Trustworthy
                  </h2>
                </div>
              </div>
              <div
                className="elementor-element elementor-element-fcd7a94 elementor-widget elementor-widget-text-editor"
                data-id="fcd7a94"
                data-element_type="widget"
                data-widget_type="text-editor.default"
              >
                <div className="elementor-widget-container">
                  <p>
                    All your sensitive information and data will remain safe and
                    sound in our system
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-753db5c elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="753db5c"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-no">
          <div
            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-4924082"
            data-id="4924082"
            data-element_type="column"
          >
            <div
              className="elementor-widget-wrap elementor-element-populated"
              style={{
                margin: 0,
              }}
            >
              <div
                className="elementor-element elementor-element-c7e263a elementor-widget elementor-widget-heading"
                data-id="c7e263a"
                data-element_type="widget"
                data-widget_type="heading.default"
              >
                <div className="elementor-widget-container">
                  <h2 className="elementor-heading-title elementor-size-default">
                    Collaborative Nature
                  </h2>
                </div>
              </div>
              <div
                className="elementor-element elementor-element-f0b05cf elementor-widget elementor-widget-text-editor"
                data-id="f0b05cf"
                data-element_type="widget"
                data-widget_type="text-editor.default"
              >
                <div className="elementor-widget-container">
                  <p>
                    Each one of us is a team player and looks forward to working
                    with you
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-2f143cd"
            data-id="2f143cd"
            data-element_type="column"
          >
            <div
              className="elementor-widget-wrap elementor-element-populated"
              style={{
                margin: 0,
              }}
            >
              <div
                className="elementor-element elementor-element-c2e9b40 elementor-widget elementor-widget-heading"
                data-id="c2e9b40"
                data-element_type="widget"
                data-widget_type="heading.default"
              >
                <div className="elementor-widget-container">
                  <h2 className="elementor-heading-title elementor-size-default">
                    Client-First Approach
                  </h2>
                </div>
              </div>
              <div
                className="elementor-element elementor-element-9419faf elementor-widget elementor-widget-text-editor"
                data-id="9419faf"
                data-element_type="widget"
                data-widget_type="text-editor.default"
              >
                <div className="elementor-widget-container">
                  <p>
                    We always put our client&apos;s needs on top of everything
                    else
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-d4ae70e"
            data-id="d4ae70e"
            data-element_type="column"
          >
            <div
              className="elementor-widget-wrap elementor-element-populated"
              style={{
                margin: 0,
              }}
            >
              <div
                className="elementor-element elementor-element-07fb832 elementor-widget elementor-widget-heading"
                data-id="07fb832"
                data-element_type="widget"
                data-widget_type="heading.default"
              >
                <div className="elementor-widget-container">
                  <h2 className="elementor-heading-title elementor-size-default">
                    Inclusive
                  </h2>
                </div>
              </div>
              <div
                className="elementor-element elementor-element-52f25b0 elementor-widget elementor-widget-text-editor"
                data-id="52f25b0"
                data-element_type="widget"
                data-widget_type="text-editor.default"
              >
                <div className="elementor-widget-container">
                  <p>
                    No matter the size, years of experience, or location, we’re
                    happy to help everyone
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
